import type from './Submit.type';

const initialState = {
  PoByDevorderSupplier: [],
  BulkFilteredPOs: [],
  SubmitLogData: [],
  DownloadLogData: [],
};

const SubmitDownloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_PO_BY_DEVORDER_SUPPLIER:
      return {
        ...state,
        PoByDevorderSupplier: action.payload,
      };
    case type.GET_BULK_FILTERED_POS:
      return {
        ...state,
        BulkFilteredPOs: action.payload,
      };
    case type.SUBMIT_DOWNLOAD_LOG:
      return {
        ...state,
        SubmitLogData: action.payload,
      };
    case type.DOWNLOAD_LOG:
      return {
        ...state,
        DownloadLogData: action.payload,
      };
    default:
      return state;
  }
};

export default SubmitDownloadReducer;
